import { IconButton } from "@shared/designSystem/Button";
import { HorizontalContainer, VerticalContainer } from "@shared/designSystem/Containers";
import { SystemIcon, SystemIconType } from "@shared/designSystem/SystemIcon";
import { SmallText, Text } from "@shared/designSystem/Texts";
import designSystemStyles from "@shared/styles/designSystemStyles";

import { QRTile, QRTileState } from "./QRTile";

export interface QRCardProps {
    iconType: SystemIconType;
    title: string;
    subtitle: string;
    downloadTitle: string;
    onDownload: () => void;
    value: string;
    state: QRTileState;
    onRetry: () => void;
    qrRef: React.RefObject<HTMLDivElement>;
}

/** QR code card with a download button (WhatsApp or app check-in QR). */
export const QRCard: React.FC<QRCardProps> = ({
    iconType,
    title,
    subtitle,
    downloadTitle,
    onDownload,
    value,
    state,
    onRetry,
    qrRef,
}) => (
    <VerticalContainer
        width="100%"
        gap={designSystemStyles.gapSm}
        backgroundColor={designSystemStyles.colorBackgroundGray2}
        borderRadius={designSystemStyles.radiusCard}
        padding={designSystemStyles.paddingLg}
    >
        <HorizontalContainer width="100%" gap={designSystemStyles.gapSm} alignment="center">
            <SystemIcon type={iconType} color={designSystemStyles.colorText} />
            <VerticalContainer width="100%" gap={designSystemStyles.gapXxxSm}>
                <Text text={`**${title.trim()}**`} markdown={true} />
                <SmallText text={subtitle} color={designSystemStyles.colorTextSecondary} />
            </VerticalContainer>
            <IconButton iconType="download" tooltip={downloadTitle} onClick={onDownload} />
        </HorizontalContainer>
        <HorizontalContainer width="100%" justifyContent="center">
            <QRTile value={value} state={state} onRetry={onRetry} qrRef={qrRef} />
        </HorizontalContainer>
    </VerticalContainer>
);

export default QRCard;
